import React from "react";
import PropTypes from "prop-types";
import AtomHed from "components/source/atoms/atom-hed";
import SubscriptionAvailabilityToggle from "components/source/shared/subscription-availability-toggle";
import { membershipStatePropType } from "components/propTypes/membership-state-prop-type";
class GridTopFiltersAvailability extends React.Component {
  static propTypes = {
    hedText: PropTypes.string,
    membershipRentalBeginDate: PropTypes.string,
    membershipState: membershipStatePropType,
    onChange: PropTypes.func,
    onClickBrowse: PropTypes.func.isRequired,
    userData: PropTypes.shape({
      isUnlimitedLens: PropTypes.bool,
      isRTRUpdateLens: PropTypes.bool,
    }),
    workingFilters: PropTypes.object,
  };

  render() {
    return (
      <div className="grid-top-filters-availability">
        <AtomHed text={this.props.hedText} />
        <div className="grid-top-filters__content">
          <SubscriptionAvailabilityToggle
            membershipRentalBeginDate={this.props.membershipRentalBeginDate}
            membershipState={this.props.membershipState}
            onChange={this.props.onChange}
            userData={this.props.userData}
            workingFilters={this.props.workingFilters}
          />
        </div>
        <div className="grid-top-filters__buttons">
          <button className="btn" onClick={this.props.onClickBrowse}>
            Save
          </button>
        </div>
      </div>
    );
  }
}

export default GridTopFiltersAvailability;
